import Button from '@material-ui/core/Button';
import * as lib from '~/dependencies';
import { colors, margins, fonts } from '~/layout';

export const Wrapper = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  overflow: scroll;
  position: relative;

  &::-webkit-scrollbar { width: 0!important; height: 0!important; }
  overflow: -moz-scrollbars-none!important; }
  -ms-overflow-style: none!important; }
`;

export const TopBar = lib.styled.div`
  background: linear-gradient(52.71deg, #00AFF0 2.79%, #0C4BBC 73.37%);
  height: 77px;
  min-height: 77px;
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  .avatar {
    border: 4px solid #FFF;
    width: 100px;
    height: 100px;
    position: absolute;
    top: 23px;
    font-size: 40px;
  }
`;

export const BoxInformations = lib.styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  :lang(nl) .boxStatus .desc {
    font-size: 9px;
    left: ${props => (props.checked ? 13 : 78)}px!important;
  }

  :lang(nl) .boxStatus .desc-off {
    font-size: 9px;
    left: ${props => (!props.checked ? 8 : 83)}px!important;
  }

  :lang(fr) .boxStatus .desc {
    font-size: 9px;
    left: ${props => (props.checked ? 15 : 86)}px!important;
  }

  :lang(fr) .boxStatus .desc-off {
    font-size: 9px;
    left: ${props => (!props.checked ? 12 : 88)}px!important;
  }
  
  :lang(pt) .boxStatus .desc {
    font-size: 9px;
    left: ${props => (props.checked ? 13 : 80)}px!important;
  }

  :lang(pt) .boxStatus .desc-off {
    font-size: 9px;
    left: ${props => (!props.checked ? 9 : 84)}px!important;
  }

  :lang(es) .boxStatus .desc {
    font-size: 9px;
    left: ${props => (props.checked ? 12 : 81)}px!important;
  }

  :lang(es) .boxStatus .desc-off {
    font-size: 9px;
    left: ${props => (!props.checked ? 11 : 84)}px!important;
  }

  :lang(de) .boxStatus .desc {
    font-size: 9px;
    left: ${props => (props.checked ? 17 : 85)}px!important;
  }

  :lang(de) .boxStatus .desc-off {
    font-size: 9px;
    left: ${props => (!props.checked ? 14 : 88)}px!important;
  }

  .boxStatus {
    position: relative;
    margin-top: 15px;

    .try-to-register {
      padding-right: 15%;
      padding-left: 15%;
      display: flex;
      align-items: center;
      flex-direction: column;
      .loading {
        margin-top: 5px;
        width: 20px!important;
        height: 20px!important;
      }
      span {
        font-size: 12px;
        color: ${colors.red04};
      }
      span:last-child {
        margin-top: 5px;
        font-weight: bold;
        cursor: pointer;
      }
    }

    .desc {
      position: absolute;
      z-index: 1;
      color: ${colors.white};
      top: 6px;
      left: ${props => (props.checked ? 15 : 90)}px!important;
      font-size: 10px;
      cursor: pointer;
    }

    .desc-off {
      position: absolute;
      z-index: 1;
      color: ${colors.darkGray07};
      top: 6px;
      left: ${props => (!props.checked ? 15 : 90)}px!important;
      font-size: 10px;
      cursor: pointer;
    }

    .react-switch-bg {
      height: 25px!important;
      width: 140px!important;
      background: #E6F0F3!important;

      div {
        width: 60px!important;
        svg {
          display: none!important;
        }
      }
    }

    .react-switch-handle {
      width: 75px!important;
      height: 25px!important;
      border-radius: 25px!important;
      top: 0px!important;
      background-color: ${props =>
        props.checked ? colors.green03 : colors.yellow01}!important;
      transform: ${props =>
        props.checked ? 'translateX(1px)' : 'translateX(64px)'}!important;
    }
  }

  .titles {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    span:first-child {
      font-size: 16px;
      color: ${colors.black};
    }
    span:last-child {
      font-size: 12px;
      color: ${colors.black};
      opacity: 0.5;
    }
  }

  .err-msg {
    font-size: 12px;
    color: ${colors.red04};
    margin-top: 7px;
  }
`;

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top:15px;

  hr {
    width: 100%;
    margin: 0px!important;
  }

  &::-webkit-scrollbar { width: 0!important; height: 0!important; }
  overflow: -moz-scrollbars-none!important; }
  -ms-overflow-style: none!important; }
`;

export const BtnLogout = lib.styled.button`
  border: 0px;
  padding: 0px;
  margin: 0px;
  box-shadow: none;
  cursor: pointer;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  margin-right: ${margins.default}px;

  span {
    margin-left: 5px;
    font-size: 14px;
    color: ${colors.darkGray07};
  }

  div {
    height: 15px!important;
  }
`;

export const ListOptions = lib.styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 15px;
  border-radius: 10px;
  border: 1px dotted ${colors.lightGray06};
  background-color: ${colors.white02};
  min-height: ${props => props.height}px;
  max-height: ${props => props.height}px;
`;

export const ItemsOptions = lib.styled(Button)`
  display: flex!important;
  flex-direction: row!important;
  align-items: center!important;
  justify-content: space-between!important;
  margin-bottom: 0px!important;
  padding: 0px 10px 0px 10px!important;
  height: 47px;
  min-height: 47px;
  border-top: 1px dotted ${colors.lightGray06}!important;

  .icon {
    div {
      height: 25px!important;
    }
  }

  &:first-child {
    border-top: 0px!important;
  }

  .row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    line-height: 20px;

    span {
      color: ${colors.black};
      font-weight: 400;
      font-size: 13px;
      text-transform: initial!important;

      &:last-child {
        font-size: 11px;
        text-transform: uppercase;
        color: rgb(0, 0, 0, 0.5);
        font-weight: 500;

        b {
          font-weight: 900;
          color: ${colors.darkBlue02};
        }
      }
    }
  }
`;

export const TopButtons = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-right: ${margins.default}px;
  width: 80px;

  button {
    background-color: transparent!important;
    text-transform: none;
    padding: 0!important;
    width: auto!important;
    min-width: auto!important;
    font-size: ${fonts.default}px;
    color: ${colors.black}!important;
    opacity: 0.5;

    &:hover {
      background-color: transparent!important;
    }

    &:last-child {
      margin-left: 15px;
    }
  }

  .active {
    color: ${colors.lightBlue}!important;
    margin-left: 15px;
  }
`;

export const InformationBox = lib.styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 11px;
  padding: 0 15px 10px 10px;

  .description {
    span {
      cursor: default;

      &:first-child {
        /* font-weight: bold; */
        user-select: none;
      }

      &:last-child {
        cursor: text;
      }
    }
  }

  &::-webkit-scrollbar { width: 0!important; height: 0!important; }
  overflow: -moz-scrollbars-none!important; }
  -ms-overflow-style: none!important; }
`;

export const SwitchGroup = lib.styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  .loading-switch {
    margin-top: 7px;
    width: 20px!important;
    height: 20px!important;
  }
`;
